<script setup>
import { computed } from 'vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';

const props = defineProps({
  status: String,
});

const form = useForm();

const submit = () => {
  form.post(route('verification.send'));
};

const verificationLinkSent = computed(() => props.status === 'verification-link-sent');
</script>

<template>
  <Head title="Email Verification" />

  <JetAuthenticationCard>
    <template #logo>
      <div v-if="$settings.login_logo_url" class="my-2 w-80 max-w-full mx-auto flex items-end justify-center">
        <img :src="$settings.login_logo_url" :alt="$settings.name" class="max-h-full max-w-full rounded object-cover" />
      </div>
      <JetAuthenticationCardLogo v-else />
    </template>

    <div class="mb-4 text-sm text-gray-600">
      Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If
      you didn't receive the email, we will gladly send you another.
    </div>

    <div v-if="verificationLinkSent" class="mb-4 font-medium text-sm text-green-600">
      A new verification link has been sent to the email address you provided during registration.
    </div>

    <form @submit.prevent="submit">
      <div class="mt-4 flex items-center justify-between">
        <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing"> Resend Verification Email </JetButton>

        <Link :href="route('logout')" method="post" as="button" class="underline text-sm text-gray-600 hover:text-gray-900"> Log Out </Link>
      </div>
    </form>
  </JetAuthenticationCard>
</template>
